<template>
  <div class="home-container">
    <!-- 顶部导航栏 -->
    <el-header class="header">
      <div class="logo">博主后台</div>
      <el-dropdown class="user-menu">
        <div class="user-info" style="border: none;">
          <el-avatar :size="40" :src="user.avatar" />
          <span class="username">{{ user.nickname }}</span>
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item @click="showEditDialog">修改信息</el-dropdown-item>
            <el-dropdown-item @click="handleLogout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </el-header>

    <!-- 主体内容 -->
    <div class="main-content">
      <!-- 左侧菜单 -->
      <el-aside width="200px" class="sidebar">
          <el-menu
          :router="true"
          :default-active="$route.path"
          class="el-menu-vertical"
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b">
          <el-menu-item index="/dashboard">
            <el-icon><PieChart /></el-icon>
            <span>数据看板</span>
          </el-menu-item>
          <el-menu-item index="/works">
            <el-icon><Document /></el-icon>
            <span>作品管理</span>
          </el-menu-item>
          <el-menu-item index="/episodes">
            <el-icon><Files /></el-icon>
            <span>分集管理</span>
          </el-menu-item>
          <el-menu-item index="/revenue">
            <el-icon><Money /></el-icon>
            <span>收益数据</span>
          </el-menu-item>
          <!-- <el-menu-item index="/copyright">
            <el-icon><ShoppingBag /></el-icon>
            <span>版权大厅</span>
          </el-menu-item> -->
          
          <!-- 提现菜单 -->
          <el-sub-menu index="withdraw">
            <template #title>
              <el-icon><Wallet /></el-icon>
              <span>提现管理</span>
            </template>
            <el-menu-item index="/withdraw/info">
              <el-icon><Document /></el-icon>
              <span>提现信息</span>
            </el-menu-item>
            <el-menu-item index="/withdraw/records">
              <el-icon><List /></el-icon>
              <span>提现记录</span>
            </el-menu-item>
          </el-sub-menu>
        </el-menu>
      </el-aside>

      <!-- 右侧内容区 -->
      <el-main class="content">
        <router-view />
      </el-main>
    </div>

    <!-- 修改信息弹窗 -->
    <el-dialog
      v-model="editDialogVisible"
      title="修改个人信息"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form :model="editForm" label-width="80px">
        <!-- 头像上传 -->
        <el-form-item label="头像">
          <div class="avatar-upload">
            <el-upload
              action="#"
              :auto-upload="false"
              :show-file-list="false"
              :on-change="handleAvatarUpload"
              accept="image/*"
            >
              <template #trigger>
                <div class="avatar-container">
                  <el-avatar :size="80" :src="editForm.avatar" />
                  <div class="avatar-overlay">
                    <el-icon><Camera /></el-icon>
                  </div>
                </div>
              </template>
            </el-upload>
            <div class="avatar-tip">点击头像可上传新头像</div>
          </div>
        </el-form-item>

        <!-- 昵称输入 -->
        <el-form-item label="昵称">
          <el-input v-model="editForm.nickname" placeholder="请输入昵称" maxlength="20" show-word-limit />
        </el-form-item>

        <!-- 密码输入 -->
        <el-form-item label="密码">
          <el-input
            v-model="editForm.password"
            type="password"
            placeholder="请输入新密码"
            show-password
          />
          <div class="password-tip">
            <el-text type="info" size="small">
              密码需8~16位数字加字母组合，不填则不修改
            </el-text>
          </div>
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSaveInfo" :loading="saveLoading">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { PieChart, Document, Files, Money, ShoppingBag, Wallet, List, Camera } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import Compressor from 'compressorjs'

export default {
  name: 'HomePage',
  components: {
    PieChart,
    Document,
    Files,
    Money,
    ShoppingBag,
    Camera
  },
  data() {
    return {
      user: {
        nickname: '未登录',
        avatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
      },
      editDialogVisible: false,
      saveLoading: false,
      editForm: {
        avatar: '',
        nickname: '',
        password: ''
      }
    }
  },
  watch: {
    '$store.getters.userInfo': {
      immediate: true,
      handler(newVal) {
        console.log('User info updated:', newVal)
        if (newVal) {
          this.user = newVal
          // 初始化编辑表单
          this.editForm = {
            avatar: newVal.avatar || '',
            nickname: newVal.nickname || '',
            password: ''
          }
        }
      }
    }
  },
 
  methods: {
    handleLogout() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/login').catch(() => {})
      })
    },
    
    showEditDialog() {
      // 初始化表单数据
      this.editForm = {
        avatar: this.user.avatar || '',
        nickname: this.user.nickname || '',
        password: ''
      }
      this.editDialogVisible = true
    },

    // 处理头像上传
    async handleAvatarUpload(file) {
      try {
        // 压缩图片
        new Compressor(file.raw, {
          quality: 0.7,
          maxWidth: 200,
          maxHeight: 200,
          convertSize: 5000000,
          mimeType: 'image/jpeg',
          success: async (compressedFile) => {
            try {
              const formData = new FormData()
              const fileName = file.name ?
                file.name.replace(/\.[^/.]+$/, '.jpg') :
                `avatar_${Date.now()}.jpg`
              const finalFile = new File([compressedFile], fileName, {
                type: 'image/jpeg',
                lastModified: Date.now()
              })
              formData.append('file', finalFile)

              const response = await this.$axios.post('api/Bloger/upload', formData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'token': localStorage.getItem('token') || ''
                },
                timeout: 30000
              })

              if (response.data && response.code == 1) {
                this.editForm.avatar = response.data.url
                ElMessage.success('头像上传成功')
              } else {
                ElMessage.error('头像上传失败: ' + (response.message || '未知错误'))
              }
            } catch (uploadError) {
              console.error('上传失败:', uploadError)
              ElMessage.error('头像上传失败')
            }
          },
          error: (err) => {
            console.error('图片压缩失败:', err)
            ElMessage.error('头像处理失败')
          }
        })
      } catch (error) {
        console.error('处理头像失败:', error)
        ElMessage.error('处理头像失败')
      }
    },

    // 验证密码格式
    validatePassword(password) {
      if (!password) return true // 密码为空时不验证
      const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,16}$/
      return passwordRegex.test(password)
    },

    // 保存个人信息
    async handleSaveInfo() {
      // 验证昵称
      if (!this.editForm.nickname.trim()) {
        ElMessage.error('请输入昵称')
        return
      }

      // 验证密码格式
      if (this.editForm.password && !this.validatePassword(this.editForm.password)) {
        ElMessage.error('密码需8~16位数字加字母组合')
        return
      }

      // 检查是否有任何字段发生变化
      const hasNicknameChanged = this.editForm.nickname !== this.user.nickname
      const hasAvatarChanged = this.editForm.avatar !== this.user.avatar
      const hasPasswordChanged = !!this.editForm.password

      // 如果没有字段发生变化
      if (!hasNicknameChanged && !hasAvatarChanged && !hasPasswordChanged) {
        ElMessage.info('没有检测到任何修改')
        this.editDialogVisible = false
        return
      }

      this.saveLoading = true
      try {
        const updateData = {}

        // 只添加有变化的字段
        if (hasNicknameChanged) {
          updateData.nickname = this.editForm.nickname
        }
        if (hasAvatarChanged) {
          updateData.avatar = this.editForm.avatar
        }
        if (hasPasswordChanged) {
          updateData.password = this.editForm.password
        }

        const response = await this.$axios.post('api/Bloger/updateUserInfo', updateData, {
          headers: {
            'token': localStorage.getItem('token') || '',
            'Content-Type': 'application/json'
          }
        })

        if (response.code == 1) {
          ElMessage.success('个人信息更新成功')
          
          if (hasPasswordChanged) {
            // 如果修改了密码，保存账户信息到 localStorage 用于自动填充
            const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
            const loginData = {
              username: userInfo.username || userInfo.account || '',
              password: this.editForm.password
            }
            localStorage.setItem('autoLoginData', JSON.stringify(loginData))
            
            // 显示提示信息
            ElMessage.success('密码修改成功，请重新登录')
            
            // 延迟跳转到登录页
            setTimeout(() => {
              this.$store.dispatch('logout').then(() => {
                this.$router.push('/login')
              })
            }, 1500)
          } else {
            // 更新本地用户信息
            this.user = {
              ...this.user,
              nickname: this.editForm.nickname,
              avatar: this.editForm.avatar
            }
            // 更新 store 中的用户信息
            this.$store.commit('SET_USER_INFO', this.user)
            this.editDialogVisible = false
          }
        } else {
          ElMessage.error('更新失败: ' + (response.message || '未知错误'))
        }
      } catch (error) {
        console.error('更新个人信息失败:', error)
        ElMessage.error('更新失败: ' + error.message)
      } finally {
        this.saveLoading = false
      }
    }
  }
}
</script>

<style scoped>
.home-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #409EFF;
  color: white;
  padding: 0 20px;
}

.logo {
  font-size: 20px;
  font-weight: bold;
}

.user-menu {
  cursor: pointer;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.username {
  font-size: 16px;
}

.main-content {
  display: flex;
  flex: 1;
  overflow: hidden;
}

.sidebar {
  background-color: #545c64;
}

.content {
  padding: 20px;
  background-color: #f0f2f5;
}

/* 头像上传样式 */
.avatar-upload {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.avatar-container {
  position: relative;
  cursor: pointer;
  border-radius: 50%;
  overflow: hidden;
  transition: all 0.3s;
}

.avatar-container:hover {
  transform: scale(1.05);
}

.avatar-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s;
  color: white;
  font-size: 20px;
}

.avatar-container:hover .avatar-overlay {
  opacity: 1;
}

.avatar-tip {
  font-size: 12px;
  color: #909399;
  text-align: center;
}

/* 密码提示样式 */
.password-tip {
  margin-top: 4px;
  line-height: 1.4;
}
</style>
